import { query } from "firebase/firestore";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { queryAllDocsByFieldSnap } from "../../utils/firebase/Firebase.utils";
import { Link } from "react-router-dom";
import UserScreenWindow from "../User/Components/UserScreenWindow";
import GatepassCard from "./GatepassCard";
import { useNavigate } from "react-router-dom";

function ContractorGatePassPage() {
  const navigate = useNavigate();
  const currentUser = useSelector((state) => state.userObject);
  const [gatePasses, setGatePasses] = React.useState([]);
  const [loading, setLoading] = React.useState(true);

  useEffect(() => {
    const fetchGatePasses = async () => {
      await queryAllDocsByFieldSnap(
        "gatePass",
        "user",
        "==",
        currentUser.email,
        (data) => {
          setGatePasses(data);
          setLoading(false);
        }
      );
    };
    fetchGatePasses();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  const handleCardClick = (id, gatePass) => {
    navigate(`/gate-pass/${id}`, {
      state: { gatePass: gatePass },
    });
  };

  return (
    <UserScreenWindow label="Contractor Gate Passes">
      <div>
        <h1 className="title-header">Contractor Gate Passes</h1>
        <Link to="/gate-pass/add" className="mt-4">
          <button className="btn btn-primary blue-button">
            Add New Gate Pass
          </button>
        </Link>
        <div className="mt-4">
          {gatePasses.map((gatePass, index) => (
            <div key={index}>
              <GatepassCard gatePass={gatePass} onClick={handleCardClick} />
            </div>
          ))}
        </div>
      </div>
    </UserScreenWindow>
  );
}

export default ContractorGatePassPage;
